<template>
<div v-if="mediaCount">
<CRow>
    <CCol col="12" class="px-0">
        <CRow>
            <CCol col="12" sm="4" md="4" lg="3" v-for="(medium, index) in media" :key="index">
                <CCard class="hover-it">
                    <CCardBody>
                        <FaIcon :icon="getIcon(medium.type)" class="fa-3x d-block mx-auto mb-3" />
                        <span class="d-block text-center">{{ medium.name }}</span>
                        <div class="text-center">
                            <span :class="'px-2 py-1 badge badge-'+mediaStatusColor(medium.status)">{{ mediaStatusStr(medium.status) }}</span>
                        </div>

                        <CLink class="link-it px-1" :href="medium.url" target="_blank">
                            <FaIcon icon="link" />
                        </CLink>
                        <CLink class="edit-it px-1" :to="{name: 'media.edit', params: {id: medium.id}}">
                            <FaIcon icon="edit" />
                        </CLink>
                        <CLink class="remove-it px-1" @click="modal = {item: medium, show: true}">
                            <FaIcon icon="trash" class="text-danger" />
                        </CLink>
                    </CCardBody>
                    <span class="d-block bg-gray-100 pb-4 pt-2 px-1 text-dark" v-if="medium.status === MediaStatus.REJECTED && medium.rejection_reason">
                        {{ $t('media.media_rejection_reason') }}: {{ medium.rejection_reason }}
                    </span>
                </CCard>
            </CCol>
        </CRow>
    </CCol>
</CRow>
<CPagination
    v-if="pagination.last_page > 1 && !pagination.no_paginate"
    :activePage.sync="pagination.current_page"
    :pages="pagination.last_page"
    align="center"
    size="sm"
    @update:activePage="fetchMedia"
/>
<CModal :title="$t('media.delete')" color="danger" :show.sync="modal.show">
    {{ $t('media.are_you_sure_to_remove', { attribute: modal.item.name }) }}
    <template #footer>
        <CButton @click="modal.show = false" color="secondary">
            {{ $t('cancel') }}
        </CButton>
        <CButton @click="deleteMedia" color="danger">
            {{ $t('delete') }}
        </CButton>
    </template>
</CModal>
</div>
<CRow v-else>
    <CCol col="12" class="px-0">
        <EmptyPage />
    </CCol>
</CRow>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { mediaStatusOption } from '@/common/data'
import { mediaStatusStr, mediaStatusColor, getIcon } from './methods'
import { MediaStatus } from '@/constants'

export default {
    name: 'Grid',

    data() {
        return {
            MediaStatus,
            mediaStatusOption,
            modal: {
                show: false,
                item: {}
            }
        }
    },

    computed: {
        ...mapGetters({
            media: 'media/media',
            pagination: 'media/pagination',
            filterMeFields: 'filterMeComponent/filterMeFields',
            mediaCount: 'media/mediaCount'
        }),
    },

    methods: {
        ...mapActions({
            fetch: 'media/fetch',
            delete: 'media/delete',
            setShowLoading: 'loadingComponent/setShowLoading'
        }),
        getIcon,
        mediaStatusStr,
        mediaStatusColor,
        fetchMedia(activePage, params) {
            this.setShowLoading(true)
            this.fetch({
                page: activePage,
                ...params,
                ...this.filterMeFields,
            }).then(() => this.setShowLoading(false))

            this.pagination.page = activePage
        },
        deleteMedia() {
            this.delete(this.modal.item.id)
                .then(() => this.modal.show = false)
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep {
    .hover-it {
        transition: all .2s;

        a.edit-it,
        a.remove-it,
        .link-it {
            position: absolute;
            opacity: 0;
            transition: all .5s;
        }

        a.edit-it {
            left: 30px;
            top: 5px;
        }

        a.remove-it {
            left: 10px;
            top: 5px;
        }

        a.link-it {
            left: 50px;
            top: 5px;
        }

        &:hover {
            a.edit-it,
            a.remove-it,
            a.link-it {
                opacity: 1;
            }
            box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 21, .08) !important;
        }
    }
}
</style>